"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createAuthenticationInterceptor(tokenProvider, apiKey) {
    return async (request) => {
        try {
            if (apiKey) {
                request.headers['x-api-key'] = apiKey;
            }
            request.headers.Authorization = `Bearer ${await tokenProvider()}`;
        }
        catch (e) {
            throw new Error('Failed to get token to authenticate request');
        }
        return request;
    };
}
function addAuthenticationToAxiosClient(instance, tokenProvider, apiKey) {
    instance.interceptors.request.use(createAuthenticationInterceptor(tokenProvider, apiKey));
    return instance;
}
exports.default = addAuthenticationToAxiosClient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXhpb3MtY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Jlc3QtY2xpZW50cy9heGlvcy1jbGllbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFJQSxTQUFTLCtCQUErQixDQUFDLGFBQTRCLEVBQ25FLE1BQWU7SUFDZixPQUFPLEtBQUssRUFBRSxPQUFPLEVBQUUsRUFBRTtRQUN2QixJQUFJLENBQUM7WUFDSCxJQUFJLE1BQU0sRUFBRSxDQUFDO2dCQUNYLE9BQU8sQ0FBQyxPQUFPLENBQUMsV0FBVyxDQUFDLEdBQUcsTUFBTSxDQUFDO1lBQ3hDLENBQUM7WUFFRCxPQUFPLENBQUMsT0FBTyxDQUFDLGFBQWEsR0FBRyxVQUFVLE1BQU0sYUFBYSxFQUFFLEVBQUUsQ0FBQztRQUNwRSxDQUFDO1FBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQztZQUNYLE1BQU0sSUFBSSxLQUFLLENBQUMsNkNBQTZDLENBQUMsQ0FBQztRQUNqRSxDQUFDO1FBQ0QsT0FBTyxPQUFPLENBQUM7SUFDakIsQ0FBQyxDQUFDO0FBQ0osQ0FBQztBQUVELFNBQXdCLDhCQUE4QixDQUFDLFFBQXVCLEVBQzVFLGFBQTRCLEVBQzVCLE1BQWU7SUFDZixRQUFRLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsK0JBQStCLENBQUMsYUFBYSxFQUFFLE1BQU0sQ0FBQyxDQUFDLENBQUM7SUFDMUYsT0FBTyxRQUFRLENBQUM7QUFDbEIsQ0FBQztBQUxELGlEQUtDIn0=